import { ReactNode } from 'react';
import ViewingMode from 'shared/components/viewing-mode-controller/types/viewing-mode';

import PersonalNumberRangeRowContext from 'features/care-connect-settings/contexts/personal-number-range-row-context';
import { PersonalNumberRange } from 'features/care-connect-settings/domain/models/personal-number-range';
import usePersonalNumberRangeRow from 'features/care-connect-settings/hooks/personal-number-range-row';

type Props = {
  children: ReactNode;
  personalNumberRange: PersonalNumberRange;
  viewingMode: ViewingMode;
};

const PersonalNumberRangeRowProvider = ({ children, personalNumberRange, viewingMode }: Props): React.JSX.Element => (
  <PersonalNumberRangeRowContext.Provider value={usePersonalNumberRangeRow(personalNumberRange, viewingMode)}>
    {children}
  </PersonalNumberRangeRowContext.Provider>
);

export default PersonalNumberRangeRowProvider;
